import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Horizontal module tab strip (Horilla oh-tabs / tk-subnav pattern).
 * items: [{ to, label, icon?, end? }]
 */
export default function ModuleSubnav({ items = [], trailing, 'aria-label': ariaLabel = 'Module navigation' }) {
  if (!items.length && !trailing) return null;

  return (
    <nav className="tk-subnav" aria-label={ariaLabel}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `tk-subnav-link${isActive ? ' is-active' : ''}`}
        >
          {item.icon ? <item.icon size={15} /> : null}
          <span>{item.label}</span>
        </NavLink>
      ))}
      {trailing ? <div className="tk-subnav-trailing">{trailing}</div> : null}
    </nav>
  );
}
